module.exports = __webpack_public_path__ + "img/duplo-diamante.578263c8.png";